import {
  HttpStatusCode,
  NotFoundError,
  ServerError,
  Success,
} from '@/api/results'

/*
  Функция обертка для обработки ошибок в серверных хуках useAsyncData или useFetchData
*/
export const fetchHandler = async <T>(
  fetchFn: () => Promise<Success<T> | NotFoundError | ServerError> | undefined,
): Promise<T | null> => {
  const result = await fetchFn()

  if (result instanceof Success) return result.data

  if (result instanceof NotFoundError) {
    throw createError({ statusCode: HttpStatusCode.NOT_FOUND })
  }

  if (result instanceof ServerError) {
    throw createError({ statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR })
  }

  return null
}
